import styles from './LoadingSpinner.module.css'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  message?: string
}

export function LoadingSpinner({ size = 'md', message }: LoadingSpinnerProps) {
  return (
    <div className={styles.wrapper}>
      <div className={[styles.spinner, styles[size]].join(' ')} role="status" aria-label="Cargando" />
      {message && <p className={styles.message}>{message}</p>}
    </div>
  )
}
